import { render, staticRenderFns } from "./PlanosPraticos.vue?vue&type=template&id=c7eb6168&scoped=true"
import script from "./PlanosPraticos.vue?vue&type=script&lang=js"
export * from "./PlanosPraticos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7eb6168",
  null
  
)

export default component.exports